import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  ReactiveFormsModule,
  FormControl,
  FormsModule,
  FormArray,
  Validators,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatChipsModule } from '@angular/material/chips';
import { NgToastService } from 'ng-angular-popup';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { FormGroup } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { RfqSectionDialogsComponent } from '@/app/components/projects/project-requests/requested-tendering/requested-rfq/rfq-section-dialogs/rfq-section-dialogs.component';
import { ProjectsService } from '@/app/services/projects/projects.service';
import { Router } from '@angular/router';
import { provideNativeDateAdapter } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { RichTextEditorComponent } from '@/app/components/shared/rich-textEditor/rich-textEditor.component';
import { environment } from '@/app/environments/environment';
import { GetFileIconUtilityService } from '@/app/services/utility/get-file-icon-utility.service';
import { RequestForQuotationService } from '@/app/services/tendering-services/rfq/rfq.service';
@Component({
  standalone: true,
  providers: [provideNativeDateAdapter()],
  imports: [
    MatChipsModule,
    MatButtonModule,
    MatSelectModule,
    ReactiveFormsModule,
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatDatepickerModule,
    RichTextEditorComponent,
  ],
  selector: 'app-rfq-commercial-submission',
  templateUrl: './rfq-commercial-submission.component.html',
  styleUrls: ['./rfq-commercial-submission.component.css'],
})
export class RfqCommercialSubmissionComponent implements OnInit {
  base_path = environment.storageUrl;
  resetRichTextEditor = false;
  isEdit = false;
  eoiTitle: FormControl<any>;
  submittedGuidlines: any;
  ittId: number;

  constructor(
    private RfqSectionDialogsComponent: RfqSectionDialogsComponent,
    private projectsService: ProjectsService,
    private toast: NgToastService,
    private router: Router,
    private requestForQuotationService: RequestForQuotationService,
    private getFileIconService: GetFileIconUtilityService
  ) {}
  @Output() closeModalEvent = new EventEmitter<boolean>(); // EventEmitter to notify parent
  @Output() commercialSubmissionDataEmitter: EventEmitter<any> =
    new EventEmitter<any>();

  @Input() rfpResponseData: any;
  @Input() tendererResponseData: any;

  oldFinancialStabilityFiles = [];
  deletedFinancialStabilityFiles = [];

  oldPerformanceBondFiles = [];
  deletedPerformanceBondFiles = [];

  oldProofOfInsuranceFiles = [];
  deletedProofOfInsuranceFiles = [];

  form: FormGroup = new FormGroup({
    title: new FormControl('', Validators.required),
    description_control: new FormControl(''),
    financial_stability_control: new FormControl(''),
    contractual_comments_control: new FormControl(''),
    performance_bond_file_control: new FormArray([]),
    financial_stability_file_control: new FormArray([]),
    proof_of_insurance_file_control: new FormArray([]),
  });

  closeModal = true;

  ngOnInit(): void {
    this.ittId = this.requestForQuotationService.getRFQId();
    this.requestForQuotationService.isEdit$.subscribe((state) => {
      this.isEdit = state;
    });

    // if (this.form) {
    //   this.mapExistingData();
    // }

    if (this.tendererResponseData) {
      this.mapRFPExistingData();
    }
  }

  get performance_bond_file_control(): FormArray {
    return this.form.get('performance_bond_file_control') as FormArray;
  }
  get proof_of_insurance_file_control(): FormArray {
    return this.form.get('proof_of_insurance_file_control') as FormArray;
  }
  get financial_stability_file_control(): FormArray {
    return this.form.get('financial_stability_file_control') as FormArray;
  }

  onFileUpload(event: any, currentControl: string): void {
    const files = event.target.files;
    console.log('The files are:', files);
    let control: any;

    if (files && files.length > 0) {
      if (currentControl === 'performance_bond_file_control') {
        control = this.form.get('performance_bond_file_control') as FormArray;
      } else if (currentControl === 'financial_stability_file_control') {
        control = this.form.get(
          'financial_stability_file_control'
        ) as FormArray;
      } else if (currentControl === 'proof_of_insurance_file_control') {
        control = this.form.get('proof_of_insurance_file_control') as FormArray;
      }
      Array.from(files).forEach((file: any) => {
        control.push(new FormControl(file));
      });
    }
  }

  // Remove new file
  removeFile(index: number, controlName: string): void {
    const control = this.form.get(controlName) as FormArray;
    control.removeAt(index); // Remove file at index
    console.log('File removed at index:', index);
  }

  // Remove old file
  removeOldFile(index: number, id: number, controlName: string): void {
    switch (controlName) {
      case 'financial_stability_file_control':
        this.deletedFinancialStabilityFiles.push(id);
        this.oldFinancialStabilityFiles.splice(index, 1);
        break;

      case 'proof_of_insurance_file_control':
        this.deletedProofOfInsuranceFiles.push(id);
        this.oldProofOfInsuranceFiles.splice(index, 1);
        break;

      case 'performance_bond_file_control':
        this.deletedPerformanceBondFiles.push(id);
        this.oldPerformanceBondFiles.splice(index, 1);
        break;

      default:
        console.warn(`Unknown control name: ${controlName}`);
        break;
    }
  }

  isImageFile(file: any) {
    const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];
    let fileExtension: any;

    if (this.isEdit && !file?.name) {
      fileExtension = file?.split('.').pop()?.toLowerCase();
    } else if (this.isEdit && file?.name) {
      fileExtension = file?.name?.split('.').pop()?.toLowerCase();
    } else {
      fileExtension = file?.name?.split('.').pop()?.toLowerCase();
    }
    return imageExtensions.includes(fileExtension || '');
  }

  moveToPreviousStep() {
    this.RfqSectionDialogsComponent.previousStep();
  }
  setContractualComments(content: string) {
    this.form.controls['contractual_comments_control'].setValue(content);
  }

  prepareDataToSubmit() {
    if (this.form.valid) {
      const formData = new FormData();

      const financial_files =
        this.financial_stability_file_control.controls.map(
          (control) => control.value
        );
      financial_files.forEach((file: File, index: number) => {
        formData.append(`financial_stability[${index}]`, file);
      });

      const proof_of_insurance_files =
        this.proof_of_insurance_file_control.controls.map(
          (control) => control.value
        );
      proof_of_insurance_files.forEach((file: File, index: number) => {
        formData.append(`proof_of_insurance[${index}]`, file);
      });

      const performance_bond_guarantee_files =
        this.performance_bond_file_control.controls.map(
          (control) => control.value
        );
      performance_bond_guarantee_files.forEach((file: File, index: number) => {
        formData.append(`performance_bond_guarantee[${index}]`, file);
      });

      formData.append('price_breakdown_title', this.form.value.title);
      formData.append(
        'price_breakdown_description',
        this.form.value.description_control
      );
      formData.append(
        'financial_stability_description',
        this.form.value.financial_stability_control
      );
      formData.append(
        'contractual_comments',
        this.form.value.contractual_comments_control
      );

      return formData;
    }
  }

  moveToNextStep() {
    this.form.markAllAsTouched();

    if (this.form.invalid) {
      this.toast.warning(
        'Please fill in all required fields.',
        'WARNING',
        4000
      );
      return;
    }
    const dataToSubmit = this.prepareDataToSubmit();
    this.requestForQuotationService
      .addRfqCommercialSubmission(dataToSubmit, this.ittId)
      .subscribe({
        next: (response) => {
          if (!response?.meta?.success) {
            return;
          }

          this.toast.success('Commercial Submission Done', 'SUCCESS');
          this.commercialSubmissionDataEmitter.emit(response?.data);
          this.RfqSectionDialogsComponent.nextStep();
        },
        error: (error: any) => {
          console.error('Failed to submit:', error);
          this.toast.danger(error.error.message, 'DANGER', 4000);
        },
      });
  }
  handleBack() {
    this.RfqSectionDialogsComponent.previousStep();
  }

  mapRFPExistingData() {
    if (!this.tendererResponseData) {
      console.warn('Tendering Response Data is undefined');
      return;
    }

    this.form.patchValue({
      title: this.tendererResponseData?.priceBreakdownTitle ?? '',
      description_control:
        this.tendererResponseData?.priceBreakdownDescription ?? '',
      financial_stability_control:
        this.tendererResponseData?.financialStabilityDescription ?? '',
      contractual_comments_control:
        this.tendererResponseData?.contractualComments ?? '',
    });

    this.oldPerformanceBondFiles =
      this.tendererResponseData?.performanceBondGuaranteeAttachments ?? [];
    this.oldFinancialStabilityFiles =
      this.tendererResponseData?.financialStabilityAttachments ?? [];
    this.oldProofOfInsuranceFiles =
      this.tendererResponseData?.proofOfInsuranceAttachments ?? [];
  }

  getFileIcon(file: {
    file: File;
    preview: string;
    id?: number;
    name?: string;
  }): string {
    return this.getFileIconService.getFileIcon(file);
  }
}
